$.plugins.counter = {
	value: 0,
	values: [],
	labels: null,
	
	__init: function (config) {
		this.apply('widget', { label: config.label, value: true }).addClass('counter');
		
		if (config.menu) {
			this.addMenu(typeof config.menu === 'object' ? config.menu : { transition: 'up' }, typeof config.menu_disabled === 'undefined' ? true : config.menu_disabled);
			this.items = [];
			
			if (typeof config.menu === 'string') {
				this.menu.addClass(config.menu);
			}
		}
		
		else {
			this.arrows = {
				dec: $.div().addClass('dec').appendTo(this).on('click', (function () {
					if (game.panel.disabled) {
						return;
					}
					
					this.dec();
				}).bind(this)),
				
				inc: $.div().addClass('inc').appendTo(this).on('click', (function () {
					if (game.panel.disabled) {
						return;
					}
					
					this.inc();
				}).bind(this)),
			};
		}
		
		if (config.values) {
			this.reset(config.values);
		}
	},
	
	reset: function (values, value, labels) {
		this.values = values;
		this.labels = labels;
		this.value = value || 0;
		
		while (this.value < 0) {
			this.value += this.values.length;
		}
		
		if (this.menu) {
			this.addClass('button');
			this.menu.clear();
			this.items = [];
			
			for (var i = 0; i < this.values.length; i++) {
				value = this.values[i];
				
				if (typeof value === 'number') {
					value = $.plugins.meter.__format(value);
				}
				
				var label = (this.labels && this.labels[i]) ? this.labels[i] : value;
				
				var item = $.div().apply('button', { label: label });
				this.menu.addItem(item);
				
				item.on('click', (function (i) {
					this.value = i;
					this.update();
				}).bind(this, i));
				
				this.items.push(item);
			}
			
			this.trigger('reset');
		}
		
		else {
			for (var b in this.arrows) {
				this.arrows[b].css('display', this.values.length > 1 ? null : 'none');
			}
		}
		
		this.update();
		
		return this;
	},
	
	update: function () {
		var value = this.values[this.value];
		
		if (typeof value === 'number') {
			value = $.plugins.meter.__format(value);
		}
		
		this.field.html((this.labels && this.labels[this.value]) ? this.labels[this.value] : value);
		
		this.trigger('update', { value: this.values[this.value], label: (this.labels && this.labels[this.value]) ? this.labels[this.value] : null });
		
		return this.values[this.value];
	},
	
	get: function (label) {
		return (label && this.labels && this.labels[this.value]) ? this.labels[this.value] : this.values[this.value];
	},
	
	set: function (value) {
		this.value = this.values.indexOf(value);
		
		if (this.value < 0) {
			this.value = 0;
		}
		
		return this.update();
	},
	
	dec: function () {
		if (this.disabled) {
			return;
		}
		
		if (this.value - 1 < 0 && !window.counter_wrap) {
			return this.update();
		}
		
		this.value = (this.value - 1 + this.values.length) % this.values.length;
		
		if (this.value < 0) {
			this.value = 0;
		}
		
		return this.update();
	},
	
	inc: function () {
		if (this.disabled) {
			return;
		}
		
		this.value = (this.value + 1) === this.values.length ? this.value : (this.value + 1);
		
		return this.update();
	},
	
	max: function () {
		if (this.disabled) {
			return;
		}
		
		this.value = this.values.length - 1;
		
		return this.update();
	},
};



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/js/counter.js
 **/